"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _HandleRoundedArrow = require("./HandleRoundedArrow");

var _TabPanel = require("./TabPanel");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var COMPONENT_MODES = {
  DEFAULT: 'default',
  GROW: 'grow'
};

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      screenSize = _ref.screenSize,
      color = _ref.color,
      variant = _ref.variant,
      onChange = _ref.onChange,
      selectedTabIndex = _ref.selectedTabIndex,
      showDivider = _ref.showDivider,
      mode = _ref.mode;
  var classes = (0, _styles.default)();

  var _useState = (0, _react.useState)(selectedTabIndex),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(_event, newValue) {
    setValue(newValue);

    if (onChange) {
      onChange(newValue);
    }
  };

  var handleSize = function handleSize() {
    var isMobile = screenSize === 'mobile';
    var maxWidth = isMobile ? 309 : 480;
    if (mode === COMPONENT_MODES.GROW && isMobile) return {
      maxWidth: maxWidth
    };
    if (mode === COMPONENT_MODES.GROW) return {};
    if (isMobile) return {
      maxWidth: maxWidth,
      maxHeight: 36
    };
    return {
      maxWidth: maxWidth,
      maxHeight: 48
    };
  };

  (0, _react.useEffect)(function () {
    setValue(selectedTabIndex);
  }, [selectedTabIndex]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    sx: handleSize()
  }, /*#__PURE__*/_react.default.createElement(_core.Tabs, {
    value: value,
    onChange: handleChange,
    indicatorColor: color,
    textColor: color,
    variant: variant,
    scrollButtons: "auto",
    allowScrollButtonsMobile: true,
    "aria-label": "scrollable force tabs example",
    ScrollButtonComponent: function ScrollButtonComponent(props) {
      return /*#__PURE__*/_react.default.createElement(_HandleRoundedArrow.HandleRoundedArrow, {
        props: props,
        screenSize: screenSize
      });
    }
  }, children.map(function (tab, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Tab, {
      "aria-label": "teste",
      id: "tab-".concat(index + 1),
      label: tab.label,
      icon: tab.icon,
      classes: {
        root: (0, _classnames.default)(classes.tab, screenSize === 'mobile' && classes.tabButtonMobile, mode === COMPONENT_MODES.GROW && classes.growModeTab)
      },
      disabled: tab.disabled
    });
  }))), children.map(function (tab, index) {
    return /*#__PURE__*/_react.default.createElement(_TabPanel.TabPanel, {
      value: value,
      index: index
    }, showDivider && /*#__PURE__*/_react.default.createElement(_core.Divider, null), tab.content);
  }));
};

exports.Tabs = Tabs;
Tabs.propTypes = {
  /**
   * Conteúdo a ser exibido quando uma Tab é selecionada. <br>
   * Deverá ser passado um array de objetos com as chaves: <br>
   * Label: string <br>
   * Content: componente <br>
   * Disabled: opcional - {true} <br>
   * icon: opcional um icone para ser exibido na tabtab.icon
   * Obs.: o componente Tabs não faz nenhuma alteração de CSS no componente utilizado como Content.
   */
  children: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /**
   * Tamanho do componente de acordo com a tela
   */
  screenSize: _propTypes.default.oneOf(['desktop', 'mobile']),

  /**
   * Cores do componente
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * Opção para ativar o scroll da Tab
   */
  variant: _propTypes.default.oneOf(['scrollable', null]),

  /**
   * Função que será chamada ao ocorrer uma mudança de tab
   */
  onChange: _propTypes.default.func,

  /**
   * Permite controlar a tab em exibição programaticamente, e/ou iniciar em uma tab específica
   */
  selectedTabIndex: _propTypes.default.number,

  /**
   * Controla a exibição de um divider abaixo da tab
   */
  showDivider: _propTypes.default.bool,

  /**
   * Alterna entre os modos
   * modo `grow` - permitte a tab crescer
   */
  mode: _propTypes.default.oneOf([COMPONENT_MODES.DEFAULT, COMPONENT_MODES.GROW])
};
Tabs.defaultProps = {
  screenSize: 'desktop',
  color: 'primary',
  variant: '',
  onChange: null,
  selectedTabIndex: 0,
  showDivider: false,
  mode: COMPONENT_MODES.DEFAULT
};
var _default = Tabs;
exports.default = _default;